import { render, staticRenderFns } from "./createBot.vue?vue&type=template&id=659983cd&scoped=true&"
import script from "./createBot.vue?vue&type=script&lang=js&"
export * from "./createBot.vue?vue&type=script&lang=js&"
import style0 from "./createBot.vue?vue&type=style&index=0&id=659983cd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659983cd",
  null
  
)

export default component.exports